import type { IconSvgObject } from './types';

const NavigationOffIcon: IconSvgObject = [
  ["path", { d: "M11.5001 6.50014L19.8473 3.06289C19.9481 3.02137 20.0561 3 20.1651 3C20.6262 3 21 3.37378 21 3.83485C21 3.94389 20.9786 4.05188 20.9371 4.15271L17.5 12.5M7.95853 7.95853L3.42691 9.8246C3.16859 9.93097 3 10.1827 3 10.4621C3 10.7785 3.21532 11.0542 3.52224 11.1309L11 13L12.8694 20.4778C12.9462 20.7847 13.2219 21 13.5383 21C13.8176 21 14.0694 20.8314 14.1758 20.5731L16.0417 16.0417", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default NavigationOffIcon;
